angular.module("suggestionModule", [])
    .directive("suggestion", [function() {
        return {
            restrict: "E",
            replace: true,
            transclde: false,
            templateUrl: "util/suggestion/suggestion_tpl.html",
            link: function(scope, elem, attrs) {
            	
            }
        };
    }]);
